import { type DragEvent } from 'react'
import { UploadCloud } from 'lucide-react'

export function InvoicePdfDropZone({
  inputId,
  file,
  onFileChange,
}: {
  inputId: string
  file: File | null
  onFileChange: (file: File | null) => void
}) {
  return (
    <>
      <button
        type="button"
        className="block w-full cursor-pointer rounded-[12px] border-2 border-dashed px-4 py-7 text-center transition-colors hover:bg-[rgba(0,113,227,0.05)]"
        style={{
          borderColor: '#CBD5E1',
          background: 'rgba(0,113,227,0.02)',
        }}
        onClick={() => document.getElementById(inputId)?.click()}
        onDragOver={(event: DragEvent<HTMLButtonElement>) => event.preventDefault()}
        onDrop={(event: DragEvent<HTMLButtonElement>) => {
          event.preventDefault()
          onFileChange(event.dataTransfer.files?.[0] ?? null)
        }}
      >
        <UploadCloud className="mx-auto size-6 text-[#94A3B8]" />
        <div className="mt-2 text-[13px] font-semibold text-[#0F172A]">
          Drag & drop files here or <span className="text-[#0071E3] underline">browse</span>
        </div>
        <div className="mt-1 break-all text-[11px] text-[#64748B]">
          {file ? file.name : 'PDF invoice evidence up to 10MB'}
        </div>
      </button>
      <input
        id={inputId}
        aria-label="Choose invoice PDF"
        className="sr-only"
        type="file"
        accept="application/pdf,.pdf"
        onChange={(event) => onFileChange(event.target.files?.[0] ?? null)}
      />
    </>
  )
}
